import { computed } from 'vue';
import { useOrganizationsStore } from '@/stores/organizations';
import type { InviteMemberRequest } from '../types';

export function useOrganizationInvites(organizationId?: string) {
  const store = useOrganizationsStore();

  const targetId = computed(() => organizationId || store.currentOrganizationId);

  const invitations = computed(() => {
    const id = targetId.value;
    return id ? store.currentInvitations : [];
  });

  const fetchInvitations = async () => {
    const id = targetId.value;
    if (id) {
      await store.fetchInvitations(id);
    }
  };

  const createInvitation = async (data: InviteMemberRequest) => {
    const id = targetId.value;
    if (id) {
      await store.createInvitation(data);
    }
  };

  const cancelInvitation = async (invitationId: string) => {
    const id = targetId.value;
    if (id) {
      await store.cancelInvitation(invitationId);
    }
  };

  const acceptInvitation = async (token: string) => {
    await store.acceptInvitation(token);
  };

  return {
    invitations,
    isLoading: computed(() => store.isLoading),
    error: computed(() => store.error),

    fetchInvitations,
    createInvitation,
    cancelInvitation,
    acceptInvitation,
  };
}
